import apiService from '../../../sdk/apiService';

// Weather Actions
export const fetchWeatherStart = () => ({
  type: 'FETCH_WEATHER_START'
});

export const fetchWeatherSuccess = (weatherData) => ({
  type: 'FETCH_WEATHER_SUCCESS',
  payload: weatherData
});

export const fetchWeatherFailure = (error) => ({
  type: 'FETCH_WEATHER_FAILURE',
  payload: error
});

// Thunk action for fetching weather data
export const fetchWeatherActions = (coordinates, cityName) => async (dispatch) => {
  dispatch(fetchWeatherStart());

  const maxRetries = 1; // Open-Meteo יציב - מספיק ניסיון אחד נוסף
  let retryCount = 0;

  const attemptFetch = async () => {
    try {
      if (!coordinates || !coordinates.lat || !coordinates.lng) {
        throw new Error('חסרים קואורדינטות לארגון');
      }

      const data = await apiService.fetchWeather(coordinates, cityName);
      dispatch(fetchWeatherSuccess(data));
    } catch (error) {
      console.error(`Weather API Error (attempt ${retryCount + 1}):`, error);

      // ניסיון חוזר רק במקרה של timeout או שגיאת רשת
      if (retryCount < maxRetries &&
        (error.name === 'AbortError' ||
          error.message.includes('timed out') ||
          error.message.includes('Failed to fetch'))) {

        retryCount++;
        const delay = 2000; // 2 שניות קבועות
        console.log(`Retrying weather fetch in ${delay}ms...`);

        setTimeout(() => {
          attemptFetch();
        }, delay);
      } else {
        dispatch(fetchWeatherFailure(error.message));
      }
    }
  };

  await attemptFetch();
};
